class DrawerMask extends HTMLElement {
  constructor() {
    super();
    this.html = document.querySelector('html');
    this.homepageScrollableElement = document.querySelector('.main-index');
    this.isHomepageScrollable =
      window.matchMedia('(min-width: 959px)').matches && this.homepageScrollableElement ? true : false;
    this.body = this.isHomepageScrollable ? this.homepageScrollableElement : document.body;
    this.scrollTopElement =
      this.isHomepageScrollable && this.homepageScrollableElement
        ? this.homepageScrollableElement
        : document.documentElement;
    this.currentScroll = 0;
    this.expandedHeader = document.querySelector('expanded-header');
  }
  show() {
    const viewportHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const isDocumentTallerThanViewport = documentHeight > viewportHeight;
    if (!isDocumentTallerThanViewport) {
      return;
    }
    this.html.dataset.pinned = '1';

    this.currentScroll = this.scrollTopElement.scrollTop;

    disableBodyScrolling(this.currentScroll);
  }

  hide() {
    this.html.removeAttribute('data-pinned');
    enableBodyScrolling(this.currentScroll);
  }
}
customElements.define('drawer-mask', DrawerMask);
